<template>
<m-pageframe
    title="{organization_label}: Custom Consent Agreements"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickNewAgreement()"
                >
                    <v-list-item-title>New Agreement...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.is_archived="{ item }">
             <v-simple-checkbox
               disabled
                v-model="item.is_archived"
            />
        </template>

        <template v-slot:item.action="{ item }">
             <v-menu 
                bottom 
                offset-y  
             >
             
             <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
             </template>
             
             <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>
             
             </v-list>
             
             </v-menu> 
        </template>
    
    </v-data-table>

    <m-edit-custom-consent-agreement-dialog
        ref="edit-custom-consent-agreement-dialog"
        v-on:ok="doUpdate"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Archived', value: 'is_archived'},
                { text: 'Context', value: 'context'},
                { text: 'Label', value: 'label'},
                { text: 'Specimen', value: 'agreement_text'},

                { text: 'Conversational', value: 'effect_conversational'},
                { text: 'Informational', value: 'effect_informational'},
                { text: 'Promotional', value: 'effect_promotional'},

                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/consent/consent-agreement',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list custom consent agreement(s)',
            });
        },
        

        onClickNewAgreement() {
            let item = {
                'organization_id': this.$route.params.organization_id,
                'agreement_id': this.$rc.uuidv4(),
                'context': 'widget',
                'label': 'Custom Consent Agreement',
                'agreement_text': 'You agreement text goes here.  You can [make a hyperlink like this](https://www.google.com)',
                'effect_conversational': 'grant',
                'effect_informational': 'grant',
                'effect_promotional': 'grant',
                'parsed_agreement': null,
                'is_archived': false,
            };

            this.onClickEdit(item);
        },

        onClickEdit(item) {
            this.$refs['edit-custom-consent-agreement-dialog'].showDialog(item);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>